import {
  LoadingManager,
  TextureLoader,
  LinearFilter,
  LinearMipmapLinearFilter,
} from "three";

const path = `/wp-content/themes/omnicom/assets/images/picture-full/`
class Assets {
  manager = new LoadingManager();
  textureLoader = new TextureLoader(this.manager);
  path;

  constructor() {
    this.diapositives0 = this.textureLoader.load( path + "image9.jpg" );
    this.diapositives0.minFilter = LinearFilter;
    this.diapositives1 = this.textureLoader.load( path + "image10.jpg" );
    this.diapositives1.minFilter = LinearFilter
    this.diapositives2 = this.textureLoader.load( path + "image11.jpg" );
    this.diapositives2.minFilter = LinearMipmapLinearFilter
    this.diapositives3 = this.textureLoader.load( path + "image12.jpg" );
    this.diapositives3.minFilter = LinearMipmapLinearFilter
    this.diapositives4 = this.textureLoader.load( path + "image13.jpg" );
    this.diapositives4.minFilter = LinearMipmapLinearFilter
    this.diapositives5 = this.textureLoader.load( path + "image14.jpg" );
    this.diapositives5.minFilter = LinearMipmapLinearFilter
    this.diapositives6 = this.textureLoader.load( path + "image15.jpg" );
    this.diapositives6.minFilter = LinearFilter
    

    this.diapositives7 = this.textureLoader.load( path + "image16.jpg" );
    this.diapositives7.minFilter = LinearFilter


    this.diapositives8 = this.textureLoader.load( path + "image17.jpg" );
    this.diapositives8.minFilter = LinearFilter
    this.diapositives9 = this.textureLoader.load( path + "image18.jpg" );
    this.diapositives9.minFilter = LinearFilter
    this.diapositives10 = this.textureLoader.load( path + "image19.jpg" );
    this.diapositives10.minFilter = LinearFilter
    this.diapositives11 = this.textureLoader.load( path + "image20.jpg" );
    this.diapositives11.minFilter = LinearFilter
    this.diapositives12 = this.textureLoader.load( path + "image21.jpg" );
    this.diapositives12.minFilter = LinearFilter


    this.dnaAssets = [
      this.diapositives0,
      this.diapositives1,
      this.diapositives2,
      this.diapositives3,
      this.diapositives4,
      this.diapositives5,
      this.diapositives6,
      this.diapositives7,
    ]
    this.graftAssets = [
      this.diapositives8,
      this.diapositives9,
      this.diapositives10,
      this.diapositives11,
      this.diapositives12,
    ]
  }
  init() {

    this.diapositives0 = this.textureLoader.load( path + "image9.jpg" );
    this.diapositives0.minFilter = LinearFilter;

    // this.atlas = this.textureLoader.load( "/wp-content/themes/omnicom/assets/images/picture-full/optimized_alvan-nee-iW8WH1Z5bFA-unsplash.jpg" );
    // this.atlas2 = this.textureLoader.load( "/wp-content/themes/omnicom/assets/images/picture-full/optimized_annie-wood-tXeK9fUkYWw-unsplash.jpg" );
    // this.atlas3 = this.textureLoader.load( "/wp-content/themes/omnicom/assets/images/picture-full/optimized_mockup-graphics-y6PeMgIa2Xo-unsplash.jpg" );
  }
}

export default new Assets();
